"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const MessageWrapper = styled_components_1.default.div `
  margin-bottom: 10px;

  .time {
    display: flex;
    justify-content: flex-end;
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
  }

  .message {
    padding: 12px 8px;
    background-color: #f5f5f5;
    border-radius: 5px 5px 5px 0;
  }
`;
const Message = ({ message, currentLocale }) => {
    const data = helpers_1.Helpers.getDateFromStringDependingLocale(message.sentAt, currentLocale);
    return (react_1.default.createElement(MessageWrapper, null,
        react_1.default.createElement("div", { className: "message" },
            message.body,
            react_1.default.createElement("div", { className: "time" },
                react_1.default.createElement(Typography_1.default, { className: "message-time", variant: "body2" }, data.time)))));
};
exports.Message = Message;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.Message));
